import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const variants = [{
  name: 'Marcelo R.',
  place: 'Palermo, CABA',
  time: 'hace 6 minutos'
}, {
  name: 'Valeria T.',
  place: 'Córdoba Capital',
  time: 'hace 18 minutos'
}, {
  name: 'Jorge P.',
  place: 'Rosario, Santa Fe',
  time: 'hace 34 minutos'
}, {
  name: 'Laura B.',
  place: 'San Isidro, GBA',
  time: 'hace 51 minutos'
}, {
  name: 'Diego F.',
  place: 'Mendoza Capital',
  time: 'hace 1 hora'
}, {
  name: 'Romina C.',
  place: 'La Plata, Buenos Aires',
  time: 'hace 2 horas'
}];
const FIRST_DELAY = 8000;
const VISIBLE = 6000;
const INTERVAL = 45000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      hideTimer = setTimeout(() => {
        setVisible(false);
        setIndex(i => (i + 1) % variants.length);
      }, VISIBLE);
    };
    const firstTimer = setTimeout(show, FIRST_DELAY);
    const cycle = setInterval(show, INTERVAL);
    return () => {
      clearTimeout(firstTimer);
      clearTimeout(hideTimer);
      clearInterval(cycle);
    };
  }, [dismissed]);
  const current = variants[index];
  return <AnimatePresence data-id="element-226" data-mp="i8a5b0zgl46r">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      x: -40
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -40
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} role="status" aria-live="polite" className="fixed bottom-20 left-5 z-50 w-[280px] rounded-lg border-l-4 border-accent bg-white p-3.5 shadow-[0_4px_20px_rgba(0,0,0,0.10)] sm:w-[320px] md:bottom-5" data-id="element-227" data-mp="i9v1sw5c2x79">
          <button onClick={() => setVisible(false)} aria-label="Cerrar notificación" className="absolute right-2 top-2 text-strike hover:text-ink" data-id="element-228" data-mp="2fmcwj7j9xy7g">
            <XIcon className="h-4 w-4" data-id="element-229" data-mp="2pksm362nkzeu" />
          </button>
          <div className="flex items-center gap-2" data-id="element-230" data-mp="1ry3duehcxqkj">
            <span className="h-2.5 w-2.5 rounded-full bg-greenlive animate-live-pulse" data-id="element-231" data-mp="1rzmx8dyb8hqj" />
            <span className="text-[11px] font-bold uppercase tracking-badge text-greenlive" data-id="element-232" data-mp="1wxy72oolus8r">
              Compra verificada
            </span>
          </div>
          <p className="mt-1.5 pr-4 text-sm leading-snug text-ink" data-id="element-233" data-mp="26mpvimugiuex">
            <span className="font-semibold" data-id="element-234" data-mp="26p2kvl2jo720">{current.name}</span> de{' '}
            {current.place} compró EstudioPack RG 5866™ 🧾
          </p>
          <p className="mt-1 text-xs text-ink-soft" data-id="element-235" data-mp="1e65gt20x7l4q">{current.time}</p>
        </motion.div>}
    </AnimatePresence>;
}